import React from "react";
import heroImg from "../../assets/hero-bg.jpg";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  return (
    <>
      <section
        id="accueil"
        className="relative flex items-center w-full min-h-screen">
        <div className="absolute inset-0">
          <img
            src={heroImg}
            alt="gamatec"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-hero-gradient" />
        </div>
        <div className="relative z-10 container-custom px-4 md:px-8 pt-20">
          <div className="max-w-5xl animate-slide-up">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-6xl font-bold text-primary-foreground leading-tight mb-6">
              Nous construisons l’excellence
              <span className="block text-secondary">
                au service de vos projets.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-primary-foreground/80 max-w-4xl mb-10 leading-relaxed">
              Depuis 2015, GRAMAGEC déploie son professionnalisme pour réaliser
              vos projets BTP en terrassement, VRD et aménagements extérieurs
              avec expertise et fiabilité.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button className="bg-gradient-to-r from-secondary to-amber-600 text-white text-sm font-medium py-2 px-6 rounded-md transition-all hover:bg-[#0f2a4d]">
                <a href="#contact">Demander un devis gratuit</a>
              </button>
              <button className="text-white text-sm font-medium py-2 px-6 rounded-md transition-all border border-secondary hover:bg-amber-600">
                <a href="#services">Nos Services</a>
              </button>
            </div>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <a
            href="#apropos"
            className="flex flex-col items-center gap-2 text-primary-foreground/60 hover:text-primary-foreground transition-colors">
            <span className="text-sm font-medium">Découvrir</span>
            <ChevronDown className="w-5 h-5" />
          </a>
        </div>
      </section>
    </>
  );
}
